var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('toolbar',[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/financial"}},[_c('i',{staticClass:"fa fa-caret-left fa-2x"}),_c('h2',[_vm._v("Financial")])]),_c('div',{staticClass:"controls"},[_c('financial-nav-tabs')],1)],1),_c('div',[_c('table-list',{attrs:{"record-name":"Project","fields":[
				{label: 'Project', key: 'projectName',type:'link'},
				{label: 'Status', key: 'status'},
				{label: 'Holdback to Date', key: 'formattedHoldback', align:'right'},
				{label: 'Holdback Release to Date', key: 'formattedHoldbackRelease', align:'right'},
				{label: 'Holdback Outstanding', key: 'formattedOutstandingHoldback', align:'right'}
			],"records":_vm.mutatedProjects}},[_c('h3',[_vm._v("Project Holdbacks")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }